/**
 * Safely parses a JSON string without throwing.
 *
 * @param {string} str - The JSON string to parse.
 * @returns {Object|null} Parsed object, or null if parsing fails.
 */
const safeJsonParse = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};

export default safeJsonParse;
